export class TabLink {
  link: string = '';
  active: boolean = false;
  index = 0;

  constructor(title: string, active: boolean, index: number) {
    this.link = title;
    this.active = active;
    this.index = index;
  }
}
